import { useMemo } from 'react'
import { usePageControls } from '~/api/hooks/useCharts'
import { useValueLabels } from '~/api/hooks/useCatalog'
import { labelFromItem } from './kpiLabel'

/** base -> display label for chart series bases and absolute-bar x-ticks. A base is either a
 *  walk-row kpi_type (ungrouped timeline series + every absolute-bar series) or ' / '-joined dim
 *  VALUES (grouped timeline series, absolute x-ticks). Translates per slash-segment: the active
 *  groupBy dims' value labels first (narrowest scope), then registry kpi labels, raw segment as
 *  the visible fallback. Series KEYS stay raw — this is render-only (V1 invariant). */
export function useSeriesBaseLabels(
  factTable: string,
  groupBy: string[],
): (base: string) => string {
  const controls = usePageControls(factTable)
  const valueLabels = useValueLabels(factTable)
  return useMemo(() => {
    const items = controls.data?.kpi_metadata?.items ?? []
    const kpiMap = new Map(items.map((m) => [m.kpi_id, labelFromItem(m)]))
    const dims = new Set(groupBy)
    const dimMap = new Map(
      (valueLabels.data ?? [])
        .filter((r) => dims.has(r.dim_name))
        .map((r) => [r.value, r.display_label]),
    )
    return (base: string) =>
      base
        .split(' / ')
        .map((seg) => dimMap.get(seg) ?? kpiMap.get(seg) ?? seg)
        .join(' / ')
  }, [controls.data, valueLabels.data, groupBy])
}
